import {
  APIs,
  API_BASE_URL,
  SERVICEURL,
  VDCLIMS,
  SHARED_SERVICEURL,
  REPORTDONESTATUS,
} from "../constants/Constants";
import axiosInterceptor from "../helpers/Interceptor";

function _base64ToArrayBuffer(base64) {
  var binary_string = window.atob(base64);
  var len = binary_string.length;
  var bytes = new Uint8Array(len);
  for (var i = 0; i < len; i++) {
    bytes[i] = binary_string.charCodeAt(i);
  }
  return bytes.buffer;
}

export const getPatientReportData = async (patientId) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.GETPATIENTREPORT,
      {
        data: {
          patientId,
        },
      },
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getStorageKeyFistolugram = async (id) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.GETFISTOLUGRAM,
      {
        data: {
          studyId: id,
        },
      },
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

// Returns raw Blob from backend instead of triggering browser download.
// Used by AnnotatedImageModal (Fistulogram config) to create an in-memory blob URL for the Cornerstone image loader.
// options.skipAudit=true tells the backend to skip the VIEW audit log (used by the
// modal's Reset path, where the re-download is not a "user viewed" event — the Reset
// action itself is captured by RESET_FISTULOGRAM_IMAGE on Save).
export const downloadFistolugramImageAsBlob = async (fileName, options = {}) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.DOWNLOADFISTOLUGRAM,
      { data: { filePath: fileName, skipAudit: options.skipAudit === true } },
      { headers: { "Content-Type": "application/json" } }
    );
    if (response.status === 200) {
      // Backend returns base64-encoded image bytes inside response.data.data.data
      const base64 = response.data.data.data;
      const byteCharacters = atob(base64);
      const byteArray = new Uint8Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteArray[i] = byteCharacters.charCodeAt(i);
      }
      // Return as Blob so the caller can create a blob URL for Cornerstone
      return new Blob([byteArray], { type: "image/jpeg" });
    }
    return null;
  } catch (error) {
    if (error.response?.status === 403) window.location.assign(APIs.REDIRECTLOGOUT);
    return null;
  }
};

// OLD: downloadFistolugramImage — triggers browser download (kept for backward compatibility)
export const downloadFistolugramImage = async (fileName) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.DOWNLOADFISTOLUGRAM,
      {
        data: {
          filePath: fileName,
        },
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    if (response.status === 200) {
      const image = new Image();
      image.src = "data:image/jpg;base64," + response.data.data.data;
      const link = document.createElement("a");
      link.href = "data:image/jpg;base64," + response.data.data.data;
      link.download = "image.jpg";
      link.appendChild(image);
      const tempDiv = document.createElement("div");
      tempDiv.style.display = "none";
      tempDiv.appendChild(link);
      document.body.appendChild(tempDiv);
      link.click();
      document.body.removeChild(tempDiv);
    }
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const uploadFistolugramService = async (id, file) => {
  var formData = new FormData();

  if (id != null) {
    const blob2 = new Blob([id], {
      type: "application/json",
    });
    formData.append("studyId", blob2);
  }
  formData.append("file", file);
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.UPLOADFISTOLUGRAM,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

// Clears the fistulogram storage key in the DB (nullifies fistulogram_storage_key /
// _file_size). Called by AnnotatedImageModal when the user saves with no annotations
// (typically after Reset) so the toolbar's green "edited" indicator disappears.
export const deleteFistolugramService = async (id) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.DELETEFISTOLUGRAM,
      { data: { studyId: id } },
      { headers: { "Content-Type": "application/json" } }
    );
    return response;
  } catch (error) {
    if (error.response?.status === 403) window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

// ─── Fibroid (NEW) ─────────────────────────────────────────────────────────
// hit the new
// /getFibroidPath, /downloadFibroid, /uploadFibroid endpoints that the backend
// is implementing alongside the new fibroid_storage_key / fibroid_file_size DB
// columns.

export const getStorageKeyFibroid = async (id) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.GETFIBROID,
      { data: { studyId: id } },
      { headers: { "content-type": "application/json" } }
    );
    return response;
  } catch (error) {
    if (error.response?.status === 403) window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

// Returns raw Blob — used by AnnotatedImageModal (Fibroid config) to create a blob URL for the image overlay.
// options.skipAudit=true → backend skips the VIEW audit log. Used by the modal's Reset path
// (which re-fetches the reference image but isn't a "user viewed" event).
export const downloadFibroidImageAsBlob = async (fileName, options = {}) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.DOWNLOADFIBROID,
      { data: { filePath: fileName, skipAudit: options.skipAudit === true } },
      { headers: { "Content-Type": "application/json" } }
    );
    if (response.status === 200) {
      const base64 = response.data.data.data;
      const byteCharacters = atob(base64);
      const byteArray = new Uint8Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteArray[i] = byteCharacters.charCodeAt(i);
      }
      return new Blob([byteArray], { type: "image/jpeg" });
    }
    return null;
  } catch (error) {
    if (error.response?.status === 403) window.location.assign(APIs.REDIRECTLOGOUT);
    return null;
  }
};

export const uploadFibroidService = async (id, file) => {
  var formData = new FormData();
  if (id != null) {
    const blob2 = new Blob([id], { type: "application/json" });
    formData.append("studyId", blob2);
  }
  formData.append("file", file);
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.UPLOADFIBROID,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403) window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

// Mirrors deleteFistolugramService — clears fibroid_storage_key in the DB.
export const deleteFibroidService = async (id) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.DELETEFIBROID,
      { data: { studyId: id } },
      { headers: { "Content-Type": "application/json" } }
    );
    return response;
  } catch (error) {
    if (error.response?.status === 403) window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getStudyReportData = async (studyId, firmId) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.GETSTUDYREPORT,
      {
        data: {
          studyId,
          firmId,
        },
      },
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getS10ReportData = async (studyId) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.GETS10REPORT,
      {
        data: {
          studyId,
        },
      },
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getReportTemplatesData = async (studyId,firmId) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.GETREPORTTEMPLATE,
      {
        data: {
          studyId: studyId,
          firmId: firmId
        },
      },
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const downloadPdfReport = async (studyId, type, useDraftSnapshot) => {
  try {
    const data = {
      studyId: studyId,
    };
    // Draft tab only: request draft snapshot for PDF download endpoint.
    if (type === "pdf" && useDraftSnapshot === true) {
      data.useDraftSnapshot = true;
    }
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.DOWNLOADREPORT + type,
      {
        data,
      }
    );
    if (
      response.status === 200 &&
      response.data.data.paymentStatus === VDCLIMS.PaymentStatusCodes.PAID
    ) {
      const fileData = _base64ToArrayBuffer(response.data.data.byteArray);
      const file = new Blob([fileData]);
      const url = window.URL.createObjectURL(file);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", response.data.data.filename);
      document.body.appendChild(link);
      link.click();
    }
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

/* Author: Tushar Saxena
   Description: Function to call API for downloading AI report
   Date: 02-02-2024
*/ 
export const downloadAIReportAPI = async (studyId) => {
  console.log("Calling API for download AI report");
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.DOWNLOADAIREPORT,
      {
        data: {
          studyId: studyId,
        },
      }
    );
    console.log("Response from download AI report", response);
    if (
      response.status === 200) {
      const fileData = _base64ToArrayBuffer(response.data.data.byteArray);
      const file = new Blob([fileData]);
      const url = window.URL.createObjectURL(file);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", response.data.data.filename);
      document.body.appendChild(link);
      link.click();
    }
    return response;
  } catch (error) {
    console.log(error);
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const previewPdfReport = async (studyId, reportDoneStatus, useDraftSnapshot) => {
  try {
    const data = {
      studyId: studyId,
    };
    // Draft tab only: request draft snapshot for /preview/pdf.
    if (useDraftSnapshot === true) {
      data.useDraftSnapshot = true;
    }
    const response = await axiosInterceptor.post(
     API_BASE_URL + APIs.PREVIEWREPORT,
      {
        data,
      }
    );
    if (
      response.status === 200 &&
      response.data.result === "SUCCESS" &&
      (reportDoneStatus === REPORTDONESTATUS.SAVED ||
        reportDoneStatus === REPORTDONESTATUS.DRAFT ||
        response.data.data.paymentStatus === VDCLIMS.PaymentStatusCodes.PAID)
    ) {
      const fileData = _base64ToArrayBuffer(response.data.data.byteArray);
      const file = new Blob([fileData], { type: "application/pdf" });
      const url = window.URL.createObjectURL(file);
      window.open(
        url, 
        "_blank", 
       `width=${window.innerWidth},height=${window.innerHeight},left=0,top=0,location=no,scrollbars=yes`
      );
      /*
      if (newWindow) {
        newWindow.document.write('<html><body style="margin:0; padding:0; height:100%;">');
        newWindow.document.write('<iframe src="' + url + '" width="100%" height="100%" style="border:none; margin:0; padding:0;"></iframe>');
        newWindow.document.write('</body></html>');
        newWindow.document.close(); // Close the document to render it
      } */
    }

    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const previewPdfWithKeyImageReport = async (studyId, reportDoneStatus, useDraftSnapshot) => {
  try {
    // Route to the plain preview endpoint (/preview/pdf), NOT the with-key-image one.
    // getPreviewReport() already embeds key images when the firm has "PDF with Key Image"
    // enabled, and — unlike /preview/pdf/pdfwithkeyimage (getPdfWithKeyImageReport, the
    // download path) — it has no download side effects, so it doesn't trigger the VDC
    // download/billing flow (no updateReportDownloaded, preview audit, not a download).
    const data = {
      studyId: studyId,
    };
    // Draft tab only: request draft snapshot for /preview/pdf.
    if (useDraftSnapshot === true) {
      data.useDraftSnapshot = true;
    }
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.PREVIEWREPORT,
      {
        data,
      }
    );
    if (
      response.status === 200 &&
      response.data.result === "SUCCESS" &&
      (reportDoneStatus === REPORTDONESTATUS.SAVED ||
        reportDoneStatus === REPORTDONESTATUS.DRAFT ||
        response.data.data.paymentStatus === VDCLIMS.PaymentStatusCodes.PAID)
    ) {
      const fileData = _base64ToArrayBuffer(response.data.data.byteArray);
      const file = new Blob([fileData], { type: "application/pdf" });
      const url = window.URL.createObjectURL(file);
      window.open(
        url,
        "_blank",
        `width=${window.innerWidth},height=${window.innerHeight},left=0,top=0,location=no,scrollbars=yes`
      );
    }

    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const loadStudyReportPdf = async (studyId) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + "jwtServices/study/report/preview/pdf/stream",
      {
        data: { studyId }
      },
      {
        responseType: "blob", 
      }
    );

    const blob = new Blob([response.data], {
      type: "application/pdf",
    });

    return URL.createObjectURL(blob);
  } catch (error) {
    console.log("error ", error);
    return "error.response";
  }
};

export const loadExternalFirmSubmittedReportPdf = async (studyId) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + "jwtServices/study/report/external/preview/pdf/stream",
      {
        data: { studyId }
      },
      {
        responseType: "blob", 
      }
    );

    const blob = new Blob([response.data], {
      type: "application/pdf",
    });

    return URL.createObjectURL(blob);
  } catch (error) {
    console.log("error ", error);
    return "error.response";
  }
};

export const toggleStudyReportPdfAttachment = async (studyId, attach) => {
  return axiosInterceptor.post(
    API_BASE_URL + "jwtServices/study/report/pdf/attach-toggle",
    {
      data: {
        studyId,
        attach,
      },
    }
  );
};

export const loadStudyReportVersionPdf = async (studyReportPdfId) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + "jwtServices/study/report/preview/pdf/stream/version",
      {
        data: { studyReportPdfId }
      },
      {
        responseType: "blob", 
      }
    );

    const blob = new Blob([response.data], {
      type: "application/pdf",
    });

    return URL.createObjectURL(blob);
  } catch (error) {
    console.log("error ", error);
    return "error.response";
  }
};

export const previewWordHistoryPdfReport = async (reportHistoryId) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.PREVIEWWORDREPORTHISTORY,
      {
        data: {
          reportHistoryId: reportHistoryId,
        },
      }
    );
    console.log(response);
    if (
      response.status === 200 &&
      response.data.result === "SUCCESS" 
    ) {
      const fileData = _base64ToArrayBuffer(response.data.data.byteArray);
      const file = new Blob([fileData], { type: "application/pdf" });
      const url = window.URL.createObjectURL(file);
      window.open(url, "_blank", "width=600,height=700,location=no");
    }

    return response;
  } catch (error) {
    console.log("error ", error);
    // if (error.response.status === 403)
    //   window.location.assign(APIs.REDIRECTLOGOUT);
    // else return error.response;
  }
};

export const previewPdfReportVersion = async (versionId) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.PREVIEWREPORTVERSION,
      {
        data: {
          versionId: versionId,
        },
      }
    );
    if (response.status === 200 && response.data.result === "SUCCESS") {
      const fileData = _base64ToArrayBuffer(response.data.data.byteArray);
      const file = new Blob([fileData], { type: "application/pdf" });
      const url = window.URL.createObjectURL(file);
      window.open(url, "_blank", "width=600,height=700,location=no");
    }

    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const saveReportTemplatesData = async (body, blitzSession) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.SAVEREPORT,
      {
        data: {
          ...body,
          blitzSession,
        },
      },
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const autosaveReportData = async (body, blitzSession) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.REPORT_AUTOSAVE,
      {
        data: {
          ...body,
          blitzSession,
        },
      },
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response?.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getReportSnapshotCheck = async (studyId) => {
  try {
    const response = await axiosInterceptor.get(
      `${API_BASE_URL}${SERVICEURL}/study/${studyId}/${APIs.REPORT_SNAPSHOT_CHECK}`
    );
    return response;
  } catch (error) {
    if (error.response?.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

/** Explicitly discard draft snapshot without updating study_report (reject path in recovery modal). */
export const discardReportSnapshot = async (studyId) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.DISCARD_REPORT_SNAPSHOT,
      {
        data: {
          studyReportSaveDto: {
            id: studyId,
          },
        },
      },
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response?.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const submitReportTemplatesData = async (body, blitzSession) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.SUBMITREPORT,
      {
        data: {
          ...body,
          blitzSession,
        },
      },
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

/* NEW (Raise Alert ordering): pre-check the same payload /submit will receive, so the
   empty Findings/Impressions and patient-sex conflict prompts can be shown before the
   Raise Alert modal instead of interrupting it afterwards.
 */
export const validateReportSubmit = async (body) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.VALIDATEREPORTSUBMIT,
      {
        data: {
          ...body,
        },
      },
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response?.status === 403) {
      window.location.assign(APIs.REDIRECTLOGOUT);
      return null;
    }
    console.warn("[submit-precheck] validate-submit failed; continuing without prompts", error);
    return null;
  }
};

export const getAllPathologies = async (studyId, firmId) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.GETALLPATHOLOGY,
      {
        data: {
          studyId: studyId,
          firmId
        },
      },
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getSelectedPathologies = async (studyId, activeData) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.GETSELECTEDPATHOLOGY,
      {
        data: {
          studyId: studyId,
          activeData
        },
      },
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const assignStudy = async (isAssign, body) => {
  try {
    const response = await axiosInterceptor.post(
      // API_BASE_URL + SERVICEURL + APIs.GETSTUDYDATA,
      API_BASE_URL + SERVICEURL + APIs.ASSIGNSTUDY,
      {
        data: {
          isAssign: isAssign,
          reportingProvider: body,
        },
      },
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const regenerateReport = async (body) => {
  try {
    const response = await axiosInterceptor.post(
      // API_BASE_URL + SERVICEURL + APIs.GETSTUDYDATA,
      API_BASE_URL + SERVICEURL + APIs.REGENERATEREPORT,
      {
        data: body,
      },
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const generateRSNADynamicReport = async (body) => {
  try {
    const response = await axiosInterceptor.post(
      // API_BASE_URL + SERVICEURL + APIs.GETSTUDYDATA,
      API_BASE_URL + SERVICEURL + APIs.GENERATERSNAREPORT,
      {
        data: body,
      },
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const generateCTBrainReportCall = async (body) => {
  try {
    const response = await axiosInterceptor.post(
      // API_BASE_URL + SERVICEURL + APIs.GETSTUDYDATA,
      API_BASE_URL + SERVICEURL + APIs.GENERATECTBRAIN,
      {
        data: body,
      },
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const generateMRISpineReportCall = async (body) => {
  try {
    const response = await axiosInterceptor.post(
      // API_BASE_URL + SERVICEURL + APIs.GETSTUDYDATA,
      API_BASE_URL + SERVICEURL + APIs.GENERATERSNAREPORT,
      {
        data: body,
      },
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getHTMLTemplate = async (id) => {
  try {
    const response = await axiosInterceptor.post(
      // API_BASE_URL + SERVICEURL + APIs.GETSTUDYDATA,
      API_BASE_URL + SERVICEURL + APIs.GETHTMLTEMPLATE,
      {
        data: {
          reportTemplateId: id,
        },
      },
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const submitQC = async (qcReviewDto, allTextToolData, blitzSession) => {
  try {
    const response = await axiosInterceptor.post(
      // API_BASE_URL + SERVICEURL + APIs.GETSTUDYDATA,
      API_BASE_URL + SERVICEURL + APIs.QCPASS,
      {
        data: {
          qcReviewDto,
          allTextToolData,
          blitzSession
        },
      },
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const reassignQCFix = async (qcReviewDto) => {
  try {
    const response = await axiosInterceptor.post(
      // API_BASE_URL + SERVICEURL + APIs.GETSTUDYDATA,
      API_BASE_URL + SERVICEURL + APIs.QCFIXREASSIGN,
      {
        data: {
          qcReviewDto
        },
      },
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getQCProvidersList = async (clientProvidersMapping) => {
  try {
    const response = await axiosInterceptor.post(
      // API_BASE_URL + SERVICEURL + APIs.GETSTUDYDATA,
      API_BASE_URL + SERVICEURL + APIs.QCPROVIDERLIST,
      {
        data: {
          clientProvidersMapping,
        },
      },
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const viewPdfReport = async (payload) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SHARED_SERVICEURL + APIs.VIEWREPORT,
      {
        data: payload,
      }
    );
    if (response.status === 200 && response.data.result === "SUCCESS") {
      const fileData = _base64ToArrayBuffer(response.data.data.byteArray);
      const file = new Blob([fileData], { type: "application/pdf" });
      const url = window.URL.createObjectURL(file);
      window.location.href = url;
    }

    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const markAsSuspect = async (studyId, firmId) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.MARKEDASSUSPECT,
      {
        data: {
          studyId,
          firmId,
        },
      },
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};
// export const downloadDoc = async (studyId) => {
//   var wordBaseURL= API_BASE_URL;
//   if( getEnv("REACT_APP_HYBRID_MODE") == "false"){
//     wordBaseURL= wordBaseURL + SHARED_SERVICEURL+"/" 
//   }
//   var wordDocUrl = wordBaseURL +"ms-word/download/doc/" + studyId + ".docx";
//   try {
//     const response = await axiosInterceptor.get(
//       API_BASE_URL + SERVICEURL + "/ms-word/getStudyReportTemplate/" + studyId
//     );
//     if (response.status === 200) {
//       const fileData = _base64ToArrayBuffer(response.data.data.byteArray);
//       const file = new Blob([fileData]);
//       const url = window.URL.createObjectURL(file);
//       const link = document.createElement("a");
//       link.href = url;
//       link.setAttribute("download", "StudyReportTemplate.json");
//       document.body.appendChild(link);
//       link.click();
//     }
//     // saveAs(
//     //   new File([JSON.stringify(response.data)], "StudyReportTemplate.json", {
//     //     type: "text/plain;charset=utf-8",
//     //   }));

//     var wordInstance = document.createElement("a");
//     wordInstance.id = "lnkMsWord";
//     var link = document.createTextNode("word link");
//     wordInstance.appendChild(link);
//     wordInstance.title = "ms-word";
//     wordInstance.href = "ms-word:ofe|u|" + wordDocUrl;
//     wordInstance.click();
//   } catch (error) {
//     if (error.response.status === 403)
//       window.location.assign(APIs.REDIRECTLOGOUT);
//     else return error.response;
//   }
// };

export const getWordSession= async (studyId)=>{
  try{
    const response = await axiosInterceptor.get(
      API_BASE_URL + SERVICEURL + APIs.GETWORDSESSION +'/' + studyId
    );
    return response;
  }catch(error){
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};


export const directReportSubmit = async(studyId) => {
  try {
    const response = await axiosInterceptor.post(API_BASE_URL + SERVICEURL + "/study/report/api/nidanpathologyfinalreportsubmit", {
      data: {
        studyReportSaveDto: {
          id: studyId,
          conflictSave: 1
        }
      }
    })

    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const addClientReportRestriction= async (body)=>{
  try{
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.ADDREPORTTEMPLATERESTRICTIONS,
      {
        data: body
      }
    );
    return response;
  }catch(error){
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
}

export const getModalityListForRestriction = async(firmId, clientId) =>{
  try{
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.MODALITYLISTFORRESTRICTION,
      {
        data: {
          "firmId": firmId,
          "clientId": clientId
        }
      }
    );
    return response;
  }catch(error){
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
}

export const regenerateLLMReport = async(llmReportDto) => {
  console.log("llm report dto : ", llmReportDto);
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.REGENERATELLMREPORT, {
        data: {
          llmReportDto
        }
      }
    )
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
}

export const getFormattedReport = async (body) => {
  try {
    const response = await axiosInterceptor.post(API_BASE_URL + SERVICEURL + APIs.GETFORMATTEDREPORT, {
      data: body,
    });
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const logAgenticEvent = async (agenticEventLogDto) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.LOGAGENTICEVENT,
      {
        data: {
          agenticEventLogDto,
        },
      },
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    console.error("Failed to log agentic event:", error);
    return null;
  }
};

